import React from 'react';
import { Fab } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { motion } from 'framer-motion';

interface SideMenuToggleProps {
  isSideMenuOpen: boolean;
  toggleSideMenu: () => void;
}

const fabVariants = {
  initial: { x: 0 },
  activated: { x: 0 },
};

export const SideMenuToggle: React.FC<SideMenuToggleProps> = ({ isSideMenuOpen, toggleSideMenu }) => {
  return (
    <motion.div
      initial="initial"
      animate={isSideMenuOpen ? "activated" : "initial"}
      style={{
        position: 'absolute',
        left: -0,
        top: '50%',
        transform: 'translateY(-50%)',
      }}
    >
      <Fab
        size="small"
        onClick={toggleSideMenu}
        sx={{
          position: 'absolute',
          left: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          bgcolor: 'white',
          '&:hover': {
            bgcolor: 'grey.200',
          },
        }}
      >
        <ChevronRightIcon />
      </Fab>
    </motion.div>
  );
};